import { Empty } from '@/components/ui/empty';
import { POLICY_SECTIONS, type PolicySection } from '../sections';

/** A section that isn't built yet: one line, no actions. */
export function SectionPlaceholder({ section }: { section: PolicySection }) {
  const label = POLICY_SECTIONS.find((entry) => entry.section === section)?.label ?? '';
  return (
    <Empty>
      <p className="text-sm text-muted-foreground">{`${label} isn't built yet.`}</p>
    </Empty>
  );
}
